import { CAMERA_PRESENTER } from '@studio/constants/Sources';

/**
 * Updates program layers with the current camera on/off status for each attendee.
 * For layers whose source type is `CAMERA_PRESENTER`, sets `layer.isCameraOn`
 * to the corresponding boolean value from `attendeeCameraStatus`.
 *
 * @param {Object<string, boolean>|null} attendeeCameraStatus - Map of attendee IDs to their camera on/off state
 * @param {Object} program - The program object containing layers to update
 * @param {Array<Object>} program.layers - Array of layer objects with `source` and optional `layer` properties
 * @returns {Object} A new program object with updated layers
 */
const updateProgramWithCameraStatuses = (attendeeCameraStatus, program) => {
  const { layers } = program;
  let updatedLayers = layers;
  if (layers) {
    updatedLayers = layers.map(layer => {
      const isCameraOn =
        layer.source.type === CAMERA_PRESENTER
          ? attendeeCameraStatus[layer.source.value]
          : undefined;
      if (typeof isCameraOn === 'boolean' && layer.layer) {
        layer.layer.isCameraOn = isCameraOn;
      }
      return layer;
    });
  }

  return {
    ...program,
    layers: updatedLayers
  };
};

export { updateProgramWithCameraStatuses };
